import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriorityWorkOfferLookupComponent } from './priority-work-offer-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PriorityWorkOfferLookupComponent],
  exports: [PriorityWorkOfferLookupComponent],
  providers: []
})
export class PriorityWorkOfferLookupModule { }
